import { render } from "./ListaPrecio.vue?vue&type=template&id=70a8c986"
import script from "./ListaPrecio.vue?vue&type=script&lang=js"
export * from "./ListaPrecio.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__